export default __webpack_public_path__ + "static/media/look-1.325428e1.png";